import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { PageHeader, Button, Form, Card, Input, Spin, Collapse, Tooltip, notification, Modal } from "antd";
import { SaveOutlined, PlusCircleTwoTone, ExclamationCircleOutlined } from '@ant-design/icons';
import { FormConfig } from "../../../../shared/config/GlobalConfig";
import AnexosVApi from "../../api/AnexosVApi";
import AnexoVSustanciasTable from "../view/AnexoVSustanciasTable";
import AnexoVSustanciaModal from "./AnexoVSustanciaModal";
import AuthenticationHelper from "../../../../shared/helpers/authenticationHelper";

const FormItem = Form.Item;
const { Panel } = Collapse;

const AnexoVForm = props => {
  const history = useHistory();
  const [sustancias, setSustancias] = useState([]);
  const [showSustanciaModal, setShowSustanciaModal] = useState(false);
  const [selectedSustancia, setSelectedSustancia] = useState(undefined);
  const [working, setWorking] = useState(false);
  const [form] = Form.useForm();
  const idsEst = JSON.parse(AuthenticationHelper.getIdsEstablecimientosUsuario(AuthenticationHelper.getId()));
  const tipoUsuario = AuthenticationHelper.getTipoUsuario().toString();
  const permisosUsuario = AuthenticationHelper.getTipoUsuario() !== 'Operador';
  let sustanciasEstablecimientosUsuario = [];
  let datos = {
    "Cuit": "",
    "Sustancias": [],
    "Utilizaciones": [],
    "PuestosAfectados": [],
    "MedidasPreventivas": [],
    "ElementosDeProteccionPersonal": [],
    "EquiposRadiologicos": [],
    "Dosimetrias": [],
    "Proveedores": [],
    "Compradores": [],
    "EstudiosAmbientalesEspecificos": [],
    "EstudiosBiologicosEspecificos": [],
    "ResponsablesDeUso": [],
    "ResponsablesDeInstalacion": [],
    "EncargadosDeProteccionRadiologica": []
  }
  let eliminarDatos = false;

  useEffect(() => {
    datos.Cuit = props.match.params.cuit;
    AuthenticationHelper.storeDatosRemove(datos);

    if (props.location.pathname.indexOf('edit') > -1 && !props.location.anexoi && !props.location.anexov) {
      history.goBack();
    }
    if (props.location.pathname.indexOf('new') > -1 && !props.location.anexoi) {
      history.goBack();
    }
    if (props.location.anexov) {
      if (tipoUsuario == "Operador") {
        let totalSustancias = props.location.anexov.Sustancias;
        idsEst.forEach(itemId => {
          totalSustancias.forEach(sustancia => {
            if(sustancia.IdEstablecimientoEmpresa == itemId){
              sustanciasEstablecimientosUsuario.push(sustancia);
            }
          });
        });
        setSustancias(sustanciasEstablecimientosUsuario);
      } else {
        setSustancias(props.location.anexov.Sustancias);
      }
    }
  }, []);

  const onFinish = values => {
    Modal.confirm({
      icon: <ExclamationCircleOutlined />,
      content: <span>¿Está seguro de querer guardar el Anexo V?</span>,
      onOk() {
        setWorking(true);
        let data = {
          //id: props.match.params.id, 
          ...values,
          Sustancias: sustancias,
        }   
        if (!props.location.anexov) {
          AnexosVApi.Save(data)
            .then(response => then(response))
            .catch(error => handleError(error));
        }
        else {
          datos = AuthenticationHelper.getDatosRemove();

          Object.keys(datos).forEach(key => {
            if (Array.isArray(datos[key]) && datos[key].length > 0) {
              eliminarDatos = true;
            }
          });

          if (eliminarDatos) {
            AnexosVApi.Delete(datos)
            .then(response => then(response))
            .catch(error => console.error(error));
          }

          AnexosVApi.Edit(data)
            .then(response => then(response))
            .catch(error => handleError(error));
        }
      },
      onCancel() { },
    });

    const then = response => {
      setWorking(false);
      if (response.status == 200 && response.data) {
        notification.success({ message: 'Éxito', description: 'Anexo V guardado', placement: 'bottomRight' });
        
        setTimeout(() => {
          AuthenticationHelper.removeDatosRemove();
          history.goBack();
        }, 400);
      } else if (response.status == 204 || !response.data) {
        notification.warning({
          message: 'Sin resultado',
          description: 'El servidor no devolvió datos. Es posible que el Anexo V no se haya guardado correctamente en la SRT.',
          placement: 'bottomRight',
          duration: 8
        });
      } else {
        notification.error({
          message: 'Error al guardar',
          description: `No se pudo guardar el Anexo V. Estado: ${response.status}`,
          placement: 'bottomRight'
        });
      }
    }

    const handleError = error => {
      setWorking(false);
      if (error.response) {
        const { status, data } = error.response;
        notification.error({
          message: 'Error al guardar Anexo V',
          description: data?.message || 'Ocurrió un error inesperado',
          duration: 6
        });
      } else {
        notification.error({
          message: 'Error de conexión',
          description: 'No se pudo conectar con el servidor',
        });
      }
    };
  };

  return (
    <div style={{ backgroundColor: '#fff' }}>
      <PageHeader
        className="site-page-header"
        title={`${props.location.anexov ? '' : 'Nuevo'} Anexo V`}
        //subTitle="Formulario"
        onBack={() => history.goBack()}
      />
      <div style={{ padding: 16, minHeight: 690 }}>
        <Spin spinning={working}>
          <Card>
            <Form
              {...FormConfig.DefaultLayout}
              form={form}
              name="formulario"
              onFinish={onFinish}
              initialValues={{ 
                ...props.location.anexov,
                Cuit: props.location.anexov?.Cuit || props.match.params.cuit || '',
                IdTipoOrganismo: props.location.anexov?.IdTipoOrganismo || props.location.anexoi?.IdTipoOrganismo,
                IdOrganismo: props.location.anexov?.IdOrganismo || props.location.anexoi?.IdOrganismo,
              }}
              scrollToFirstError
            >
              <FormItem name="Cuit" label="Cuit" rules={FormConfig.DefaultRules} initialValue={props.match.params.cuit}>
                <Input disabled />
              </FormItem>

              {props.location.anexov?.IdTipoOrganismo || props.location.anexoi?.IdTipoOrganismo ? <FormItem name="IdTipoOrganismo" label="Tipo Organismo" rules={FormConfig.DefaultRules}>
                <Input disabled />
              </FormItem> : ''}

              {props.location.anexov?.IdOrganismo || props.location.anexoi?.IdOrganismo ? <FormItem name="IdOrganismo" label="Organismo" rules={FormConfig.DefaultRules}>
                <Input disabled />
              </FormItem> : ''}

              <Collapse style={{ marginBottom: 24 }}>
                {
                  permisosUsuario && (props.location.puedeEditar == true || !props.location.anexov) ?
                    <>
                      <Panel header="Sustancias" key="1"
                        extra={<Tooltip title="Agregar" placement="left"><PlusCircleTwoTone twoToneColor="#f15e21"
                          onClick={event => {
                            event.stopPropagation();
                            setSelectedSustancia(undefined);
                            setShowSustanciaModal(true);
                          }}
                        /></Tooltip>}
                      >
                        {sustancias.length > 0
                          ? <div style={{ overflow: 'auto', width: '100%' }}>
                            <AnexoVSustanciasTable formMode
                              cuit={props.match.params.cuit}
                              anexoi={props.location.anexoi}
                              puedeEditar={props.location.puedeEditar}
                              Sustancias={sustancias}
                              onRemove={record => { 
                                setSustancias([...sustancias.filter(item => (item.IdSustanciaDeclarada !== record.IdSustanciaDeclarada))]); 
                                datos = AuthenticationHelper.getDatosRemove();
                                datos.Sustancias.push(record.IdSustanciaDeclarada);
                                AuthenticationHelper.storeDatosRemove(datos);
                                }}
                              onEdit={record => {
                                setSelectedSustancia(record);
                                setShowSustanciaModal(true);
                              }}
                            /></div>
                          : ''}
                      </Panel>
                    </> :
                    <>
                      <Panel header="Sustancias" key="1">
                        {sustancias.length > 0
                          ? <div style={{ overflow: 'auto', width: '100%' }}>
                            <AnexoVSustanciasTable formMode
                              cuit={props.match.params.cuit}
                              anexoi={props.location.anexoi}
                              puedeEditar={props.location.puedeEditar}
                              Sustancias={sustancias}
                              onRemove={record => { 
                                setSustancias([...sustancias.filter(item => (item.IdSustanciaDeclarada !== record.IdSustanciaDeclarada))]); 
                                datos = AuthenticationHelper.getDatosRemove();
                                datos.Sustancias.push(record.IdSustanciaDeclarada);
                                AuthenticationHelper.storeDatosRemove(datos);
                                }}
                              onEdit={record => {
                                setSelectedSustancia(record);
                                setShowSustanciaModal(true);
                              }}
                            /></div>
                          : ''}
                      </Panel>
                    </>
                }

              </Collapse>

              <FormItem wrapperCol={{ span: 24 }} style={{ textAlign: 'right' }}>
                {
                  permisosUsuario ?
                    <>
                      <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>Guardar</Button>
                    </> : null
                }
              </FormItem>
            </Form>
            {
              showSustanciaModal ?
                <>
                  <AnexoVSustanciaModal
                    cuit={props.match.params.cuit}
                    sustancia={selectedSustancia}
                    anexoi={props.location.anexoi}
                    visible={showSustanciaModal}
                    onOk={sustancia => {
                      let arr = [...sustancias];
                      let idx = arr.findIndex(x => x.Hash ? x.Hash === sustancia.Hash : x.IdSustanciaDeclarada === sustancia.IdSustanciaDeclarada);
                      if (idx !== -1) { arr[idx] = sustancia; }
                      else { arr.push(sustancia); }
                      setSustancias([...arr]);
                      setShowSustanciaModal(false);
                    }}
                    onCancel={() => setShowSustanciaModal(false)}
                  />
                </> : null
            }
          </Card>
        </Spin>
      </div>
    </div>
  );
}

export default AnexoVForm;